/* import __COLOCATED_TEMPLATE__ from './most-common-topics-footer-cta.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();